import React, { Component } from 'react'
import DownloadIcon from '@mui/icons-material/Download';
import IconButton from '@mui/material/IconButton';

export default class DownloadBtn extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isShow: false,
            downloadOptions: []
        }
    }
    componentDidMount() {
        let options = this.props.options
        if (options.indexOf(',') > -1) {
            this.setState({ downloadOptions: options.split(',') })
        } else {
            this.setState({ downloadOptions: [options] })
        }
    }
    render() {
        return (
            <>
            {
                this.state.isShow && <div style={{width:"100vw",height:"100vh",position:"absolute",top:"0",right:"0",zIndex:99998 }} onClick={() => this.setState({isShow:false})}></div>
            }
                <div className="dropdown">
                    <IconButton onClick={() => this.setState({ isShow: !this.state.isShow })}>
                        <DownloadIcon />
                    </IconButton>
                    <div id="myDropdown" className="dropdown-content" style={{ display: this.state.isShow ? "block" : "none" }}>
                        {
                            this.state.downloadOptions.map((option, index) => {
                                return (
                                    <span key={index} onClick={() => this.props.onDownload && this.setState({ isShow: !this.state.isShow }, () => this.props.onDownload(option))}>{option.toUpperCase()}</span>
                                )
                            })
                        }
                    </div>
                </div>
            </>
        )
    }
}
